import React from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

const DialogCloseButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, type = "button", ...props }, ref) => (
  <button
    ref={ref}
    className={cn(
      "absolute right-4 top-4 flex size-8 shrink-0 items-center justify-center rounded-full bg-secondary-light text-contrast-light ring-offset-background transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none",
      className
    )}
    type={type}
    {...props}
  >
    <X className="size-5" />
    <span className="sr-only">Close</span>
  </button>
));

DialogCloseButton.displayName = "DialogCloseButton";

export default DialogCloseButton;
